/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ExternalTaskType {
  Unknown = 'Unknown',
  Form = 'Form',
  DocumentRequirement = 'DocumentRequirement',
  SignatureRequirement = 'SignatureRequirement',
  IdentityVerification = 'IdentityVerification',
  Bespoke = 'Bespoke'
}
